import { useIntl } from 'react-intl';


/* eslint-disable */
export const endpoints = {
	COGNITO_URL: process.env.COGNITO_URL,
	COGNITO_API_KEY: process.env.COGNITO_API_KEY,
	WSS_READINGS: process.env.WSS_READINGS,
	GRAPHQL_GENERAL: process.env.GRAPHQL_GENERAL,
	COGNITO_DOMAIN_USER_POOL_EXTERNAL: process.env.COGNITO_DOMAIN_USER_POOL_EXTERNAL,
	COGNITO_CLIENT_ID: process.env.COGNITO_CLIENT_ID,
	CLOUD_WEBSITE: process.env.CLOUD_WEBSITE,
	PX_CLOUD_API: process.env.PX_CLOUD_API,
	VERSION_PUBLISH: process.env.VERSION_PUBLISH,
	WSS_READINGS: process.env.WSS_READINGS,
	PULS_URL: process.env.PULS_URL,
	ENVIRONMENT: process.env.ENVIRONMENT,
	CALAMP_URL: process.env.CALAMP_URL,
	SALESFORCE_URL: process.env.SALESFORCE_URL,
	REPOSITORY_CODE: process.env.REPOSITORY_CODE,
	PUBLIC_REPOSITORY_CODE: process.env.PUBLIC_REPOSITORY_CODE,
	GRAPHQL_PX_REPORTING: process.env.GRAPHQL_PX_REPORTING
};

export const optionsTimeFrame = (returnCustom) => {
	const { messages } = useIntl();
	let timeframes =
		[
			{
				Id: "today",
				Nametag: messages['today'],
			},
			{
				Id: "yesterday",
				Nametag: messages['yerterday'],
			},
			{
				Id: "week",
				Nametag: messages['this_week'],
			},
			{
				Id: "lastWeek",
				Nametag: messages['last_week'],
			},
			{
				Id: "thisMonth",
				Nametag: messages['this_month'],
			},
			{
				Id: "lastMonth",
				Nametag: messages['last_month'],
			},
			{
				Id: "quarter",
				Nametag: messages['this_quarter'],
			},
			{
				Id: "lastQuarter",
				Nametag: messages['last_quarter'],
			}

		]

	if (returnCustom)
		timeframes.push({
			Id: "custom",
			Nametag: messages['custom']
		})

	return timeframes
}
